import { BaseDto } from "src/dtos/common/baseDto";
import { SalesDetailDto, SalesHeaderDto } from "src/dtos/sales/salesBillDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SAL2020_R01Dto {
	salesBillHeaderDto: SAL2020_R01HeaderDto;
	salesBillDetailDtoList: SAL2020_R01DetailDto[];
}

export interface SAL2020_R01HeaderDto extends SalesHeaderDto {
}

export const defaultSAL2020_R01HeaderDto: SAL2020_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	salBillNo: '',
	compCd: '',
	compNm: '',
	customCd: '',
	customNm: '',
	vatType: '',
	salesDt: formatDate(new Date()),
	deliveryDt: formatDate(new Date()),
	post: '',
	address: '',
	detailAddress: '',
	moneyCd: '',
	salesAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	periodDt: formatDate(new Date()),
	telNo: '',
	faxNo: '',
	taxBilling: 'N',
	taxBillNo: '',
	empNo: '',
	empNm: '',
	approveFlg: 'N',
	remark: '',
	
	inserted: false,
	isModified: false
}

// 판매실적 상세 DTO (단일 상속 방식)
export interface SAL2020_R01DetailDto extends SalesDetailDto {
}


export const defaultSAL2020_R01DetailDto: SAL2020_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	salBillNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	salesDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	itemSeq: 0,
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	itemCd: '',
	unit: '',
	salesQty: 1,
	salesPrice: 0,
	dcAmt: 0,
	itemAmt: 0,
	transportNo: '',
	remark: '',

	inserted: false,
	isModified: false
}
